import React, { useCallback, useEffect, useMemo, useState } from "react";

import {
  AppBar,
  Autocomplete,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  Divider,
  Fade,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  Modal,
  Paper,
  Popover,
  Popper,
  Slide,
  Switch,
  SwitchProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import * as XLSX from "xlsx";
import {saveAs} from "file-saver";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import DeleteIcon from "@mui/icons-material/Delete";
import { FormControl } from "@mui/material";
import {
  ThemeProvider,
  createTheme,
  makeStyles,
  styled,
} from "@mui/material/styles";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { enqueueSnackbar } from "notistack";

import axios from "axios";
import axiosInstance from "../../components/layout/AxiosInstance";
import useAxiosInterceptor from "../../components/layout/AxiosInstance";

import { Navigate, useNavigate } from "react-router-dom";
import BarChartIcon from "@mui/icons-material/BarChart";
import { useDispatch, useSelector } from "react-redux";

import dayjs, { Dayjs } from "dayjs";

import { format } from "date-fns";

import { Console } from "console";

import { date } from "../Form Add/AddForm";
import FileUploadComponent from "../../components/Excel/FileUpload";
import NothingToDisplayImage from "../../asset/NothingToDisplayImage.png";

import { setisOpen } from "../../store/ModalSlice";
import capitalizeFirstLetter from "../../components/functions/NameFunc";
import Footer from "../../components/Page Component/Footer";
import Navbar from "../../components/Page Component/Navbar";
import Sidebar from "../../components/Page Component/Sidebar";
import {
  DeleteEmp,
  activeStatusChange,
  registerUser,
  updateEmployee,
  viewUsers,
  managerAssignmentsUrl,
} from "../../Service/Apis";
import { setIsLoading } from "../../store/LoadingSlice";
import Skeletons from "../../components/Skeleton/Skeletons";
import {
  ToastVariant,
  useCustomToast,
} from "../../components/Methods/SnackBar";
import {
  DataPayload,
  FetchDataFailureAction,
  FetchDataSuccessAction,
  deleteData,
  fetchData,
  patchData,
  postData,
} from "../../store/actions";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { RootState } from "../../store/Store";
import { setEmpId } from "../../store/FormSlice";
import { postDataSuccess } from "../../store/AxiosSlice";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../components/Data/NoRowsOverlayComponent";
import Loading from "../../components/Loading/Loading";
import NothingToDisplayComponent from "../../components/Data/NothingToShowComponent";
import { getDataGridPaginationProps } from "utils/paginationConfig";
import PageTitle from "../../components/Page Component/PageTitle"


const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  p: 4,
};

type initialemp = {
  first_name: string;
  last_name: string;
  role: string[];
  email: string;
  password: string;
};

const initialStateEmployee = {
  id: "",
  employee_code: "",
  first_name: "",
  last_name: "",
  gender: "",
  roles: [],
  designation: "",
  date_of_birth: "",
  date_of_joining: "",
  date_of_confirmation: "",
  date_of_exit: "",
  email: "",
  password: "",
  is_active:true,
};
const AddEmployee = () => {
  const [open, setOpen] = React.useState(false); //Open Add Employee Modal.
  const [addEmployee, setAddEmployee] = useState(initialStateEmployee); //State for add employee.
  const [roles, setRoles] = useState<string[]>([]); // Set Roles.
  const [getEmployee, setGetEmployee] = useState<
    (typeof initialStateEmployee)[]
  >([]); // State to get the employee details.
  const [dateOfJoining, setDateOfJoining] = React.useState<Dayjs | null>(
    dayjs(`${date}`)
  );
  const [dateOfBirth, setDateOfBirth] = React.useState<Dayjs | null>(
    dayjs(`${date}`)
  );

  const [openEdit, setOpenEdit] = useState(true); //Enable Edit.
  const [showPassword, setShowPassword] = useState(false); //Show Password.
  const [passwordFocused, setPasswordFocused] = useState(false); //Focus Password.
  const [isValidPassword, setIsValidPassword] = useState<{
    specialCharacter: boolean;
    oneUpperCase: boolean;
    oneLowerCase: boolean;
    oneNumber: boolean;
    minCharacter: boolean;
    spacesError: boolean;
  }>({
    specialCharacter: false,
    oneUpperCase: false,
    oneLowerCase: false,
    oneNumber: false,
    minCharacter: false,
    spacesError: false,
  }); // Validation for password.

  const [editRole, setEditRole] = useState(false);
  const [personData, setPersonData] = useState<{
    employee_code: string;
    first_name: string;
    last_name: string;
    gender: string;
    roles: string[];
    designation: string;
    email: string;
    password: string;
    date_of_joining: string;
    date_of_birth: string;
  }>({
    employee_code: "",
    first_name: "",
    last_name: "",
    gender: "",
    roles: [],
    designation: "",
    email: "",
    password: "",
    date_of_joining: "",
    date_of_birth: "",
  }); // State to edit employee details.

  const IOSSwitch = styled((props: SwitchProps) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 1,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : theme.palette.primary,
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 12,
      height: 12,
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const [viewModal1, setViewModal1] = useState<number | null>(null); //Open View Modal.
  const [editModal2, setEditModal2] = useState<number | null>(null); // Delete Modal.
  const [activeStatusModal, setActiveStatusModal] = useState<number | null>(
    null
  ); // Delete Modal.
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("active"); 
  const [reportingManagerFilter, setReportingManagerFilter] = useState<string[]>([]); 
  
  const [m1Managers, setM1Managers] = useState<Record<string, string>>({});
  const [m2Managers, setM2Managers] = useState<Record<string, string>>({});
  const [editEmployee, setEditEmployee] = useState();

  const [count, setCount] = useState(0); // To call API again.

  const [selectedGender, setSelectedGender] = useState("");
  const [otherGender, setOtherGender] = useState(""); //To store Other Gender.

  const dispatch = useDispatch();
  const Navigate = useNavigate();

  const [isSpecialCharError, setIsSpecialCharError] = useState(false);
  const [isSpecialCharError2, setIsSpecialCharError2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isS, setIsS] = useState(false); //Password Validation Error.

  const [nameError, setNameError] = useState<boolean[]>([]); // Name Validation.
  const [anchorEl, setAnchorEl] = useState(null);

  const navigate = useNavigate();
  const selectedRole = useSelector((state: any) => state.auth.selectedRole);
  const canJiraEmployeeAnalytics =
    selectedRole === "Admin" || selectedRole === "HR";
  const isloading = useSelector((state: any) => state.loading.isLoading);

  const isOpen = useSelector((state: any) => state.modal.isOpen);
  const counts = useSelector((state: any) => state.loading.count);

  const showToast = useCustomToast();

  // const success = useSelector((state: any) => state?.http?.data);
  const filteredData = useMemo(() => {
    let filtered = getEmployee;
    
    if (statusFilter === "active") {
      filtered = filtered.filter((emp) => emp.is_active === true);
    } else if (statusFilter === "inactive") {
      filtered = filtered.filter((emp) => emp.is_active === false);
    }
    
    if (reportingManagerFilter.length > 0) {
      filtered = filtered.filter((emp) => {
        const m1Name = m1Managers[emp.id] || "";
        const m2Name = m2Managers[emp.id] || "";
        return reportingManagerFilter.some((filterName) =>
          m1Name.toLowerCase().includes(filterName.toLowerCase()) ||
          m2Name.toLowerCase().includes(filterName.toLowerCase())
        );
      });
    }
    
    if (searchTerm !== "") {
      filtered = filtered.filter((employee) =>
        Object.values(employee).some(
          (value) =>
            value &&
            value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
    
    return filtered;
  }, [getEmployee, searchTerm, statusFilter, reportingManagerFilter, m1Managers, m2Managers]);


  const rows = useMemo(() => {
    return filteredData.map((employee, index) => ({
      ...employee,
      name: employee.first_name + " " + employee.last_name,
      reporting_manager_m1: m1Managers[employee.id] || "Unassigned",
      reporting_manager_m2: m2Managers[employee.id] || "Unassigned",
      index: index,
    }));
  }, [filteredData, m1Managers, m2Managers]);

  const columns: GridColDef[] = useMemo(() => [
    {
      field: "employee_code",
      headerName: "Employee Code",
      flex: 0.5,
      minWidth: 90,
      align: "center",
      headerAlign: "center",
      headerClassName: "header-background",
      renderHeader: () => (
        <strong className="custom-header" style={{ fontSize: 15, display: "block", textAlign: "center", lineHeight: 1.2 }}>
          Employee<br />Code
        </strong>
      ),
    },
    {
      field: "name",
      headerName: "Employee Name",
      flex: 1.2,
      minWidth: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "header-background",
      renderHeader: () => (
        <strong className="custom-header" style={{ fontSize: 15 }}>
          Employee Name
        </strong>
      ),
      renderCell: (params) => (
        <Tooltip title="Double-click to view employee" placement="top">
          <Box
            onDoubleClick={() => {
              Navigate("/viewEmployee");
              dispatch(setEmpId(params.row.email));
              localStorage.setItem("viewEmail", params.row.email);
            }}
            sx={{ cursor: "pointer", width: "100%", textAlign: "center" }}
          >
            {params.row.name}
          </Box>
        </Tooltip>
      ),
    },
    {
      field: "designation",
      headerName: "Designation",
      flex: 1.2,
      minWidth: 160,
      align: "center",
      headerAlign: "center",
      headerClassName: "header-background",
      renderHeader: () => (
        <strong className="custom-header" style={{ fontSize: 15 }}>
          Designation
        </strong>
      ),
    },
    {
      field: "reporting_manager_m1",
      headerName: "Reporting Manager 1",
      flex: 1.2,
      minWidth: 160,
      align: "center",
      headerAlign: "center",
      headerClassName: "header-background",
      renderHeader: () => (
        <strong className="custom-header" style={{ fontSize: 15, display: "block", textAlign: "center", lineHeight: 1.2 }}>
          Reporting<br />Manager 1
        </strong>
      ),
      valueGetter: (params) => params.row.reporting_manager_m1 || "Unassigned",
      renderCell: (params) => (
        <Tooltip title="Double-click to assign manager" placement="top">
          <Box
            onDoubleClick={() =>
              Navigate("/assign-manager/form", {
                state: { preselectedEmployeeId: params.row.id },
              })
            }
            sx={{ cursor: "pointer", width: "100%", textAlign: "center" }}
          >
            {params.row.reporting_manager_m1 || "Unassigned"}
          </Box>
        </Tooltip>
      ),
    },
    {
      field: "reporting_manager_m2",
      headerName: "Reporting Manager 2",
      flex: 1.2,
      minWidth: 160,
      align: "center",
      headerAlign: "center",
      headerClassName: "header-background",
      renderHeader: () => (
        <strong className="custom-header" style={{ fontSize: 15, display: "block", textAlign: "center", lineHeight: 1.2 }}>
          Reporting<br />Manager 2
        </strong>
      ),
      valueGetter: (params) => params.row.reporting_manager_m2 || "Unassigned",
      renderCell: (params) => (
        <Tooltip title="Double-click to assign manager" placement="top">
          <Box
            onDoubleClick={() =>
              Navigate("/assign-manager/form", {
                state: { preselectedEmployeeId: params.row.id },
              })
            }
            sx={{ cursor: "pointer", width: "100%", textAlign: "center" }}
          >
            {params.row.reporting_manager_m2 || "Unassigned"}
          </Box>
        </Tooltip>
      ),
    },
    {
      field: "Options",
      headerName: "Options",
      flex: 0.6,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      headerClassName: "header-background",
      renderHeader: () => (
        <strong className="custom-header" style={{ fontSize: 15 }}>
          Options
        </strong>
      ),
      renderCell: (params) => (
        <>
          {canJiraEmployeeAnalytics && (
            <Tooltip title="Jira analytics (this employee)">
              <IconButton
                id={`jira_analytics_${params.row.index + 1}`}
                onClick={() =>
                  navigate(
                    `/employeeinformation/${params.row.id}?months=1`
                  )
                }
                color="primary"
                size="small"
              >
                <BarChartIcon />
              </IconButton>
            </Tooltip>
          )}
          {/*
          <Tooltip title="Delete">
            <IconButton
              id={`delete_button_${params.row.index + 1}`}
              onClick={() => {
                handleOpenModal2(params.row.index);
              }}
              color="primary"
              size="small"
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
          */}
          <Modal
            open={editModal2 === params.row.index}
            onClose={handleCloseModal2}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            slotProps={{
              backdrop: {
                style: {
                  backgroundColor: "transparent",
                },
              },
            }}
          >
            <Card elevation={11} sx={style}>
              <Typography
                id={`confirmation_${params.row.index + 1}`}
                variant="h6"
                component="h2"
                fontWeight={"bold"}
              >
                Confirmation
              </Typography>
              <Typography
                id={`confirmation_content_${params.row.index + 1}`}
                sx={{ mt: 2 }}
              >
                Do you want to delete?
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  alignItems: "center",
                  m: 1,
                  p: 1,
                }}
              >
                <Button
                  id={`no_button_${params.row.index + 1}`}
                  onClick={handleCloseModal2}
                >
                  No
                </Button>
                <Button
                  id={`yes_button_${params.row.index + 1}`}
                  variant="contained"
                  onClick={() => {
                    handleDelete(params.row.email);
                  }}
                >
                  Yes
                </Button>
              </Box>
            </Card>
          </Modal>
        </>
      ),
      //   width: 400,
    },
    {
      field: "is_active",
      headerName: "Status",
      flex: 0.4,
      minWidth: 70,
      align: "center",
      headerAlign: "center",
      headerClassName: "header-background",
      renderHeader: () => (
        <strong className="custom-header" style={{ fontSize: 15 }}>
          Status
        </strong>
      ),
      renderCell: (params) => (
        <>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <FormControlLabel
              control={
                <IOSSwitch
                  sx={{ m: 1 }}
                  checked={params.row.is_active}
                  onChange={(e) => setActiveStatusModal(params.row.index)}
                />
              }
              label=""
            />
            <Modal
              open={activeStatusModal === params.row.index}
              onClose={() => {
                setActiveStatusModal(null);
              }}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              slotProps={{
                backdrop: {
                  style: {
                    backgroundColor: "transparent",
                  },
                },
              }}
            >
              <Card elevation={11} sx={style}>
                <Typography
                  id={`confirmation_${params.row.index + 1}`}
                  variant="h6"
                  component="h2"
                  fontWeight={"bold"}
                >
                  Confirmation
                </Typography>
                <Typography
                  id={`confirmation_content_${params.row.index + 1}`}
                  sx={{ mt: 2 }}
                >
                  Do you want to change the status of {params.row.name} from{" "}
                  {params.row.is_active ? "Active" : "Deactive"} to{" "}
                  {!params.row.is_active ? "Active" : "Deactive"}?
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    m: 1,
                    p: 1,
                  }}
                >
                  <Button
                    id={`no_button_${params.row.index + 1}`}
                    onClick={() => {
                      setActiveStatusModal(null);
                    }}
                  >
                    No
                  </Button>
                  <Button
                    id={`yes_button_${params.row.index + 1}`}
                    variant="contained"
                    onClick={() => {
                      handleActiveStatusChange(
                        params.row.id,
                        params.row.is_active
                      );
                      setActiveStatusModal(null);
                    }}
                  >
                    Yes
                  </Button>
                </Box>
              </Card>
            </Modal>
          </Box>
        </>
      ),
      //   width: 400,
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [canJiraEmployeeAnalytics, Navigate, dispatch, navigate, editModal2, activeStatusModal]);

  const dispatch2: ThunkDispatch<
    RootState,
    null,
    FetchDataSuccessAction | FetchDataFailureAction
  > = useDispatch();

  const handleActiveStatusChange = useCallback(async (
    employeeId: string,
    isActive: boolean
  ) => {
    const data = {
      employee_id: employeeId,
      is_active: isActive,
    };
    try {
      const response = await dispatch2(postData(activeStatusChange, data));
      showToast("Status Changed !", "success", true);
      
      // Update local state instead of refetching
      setGetEmployee((prevEmployees) =>
        prevEmployees.map((emp) =>
          emp.id === employeeId ? { ...emp, is_active: !isActive } : emp
        )
      );
    } catch (error) {
      console.log(error);
    }
  }, [dispatch2, showToast]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setIsSpecialCharError(false);
    setRoles([]);
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
  };

  const handleEdit = () => {
    setOpenEdit(!openEdit);
  };

  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const handleShowToast = useCallback((
    message: string,
    variant: ToastVariant,
    isCloseable: boolean
  ) => {
    showToast(message, variant, isCloseable);
  }, [showToast]);

  const handlePasswordFocus = (event: any) => {
    setPasswordFocused(true);
    setAnchorEl(event.currentTarget);
  };

  const handlePasswordBlur = () => {
    setPasswordFocused(false);
    setAnchorEl(null);
  };

  const handleOpenModal1 = (index: number) => {
    setViewModal1(index);
  };

  const handleCloseModal1 = () => {
    setViewModal1(null);
    setNameError([]);
    setIsSpecialCharError2(false);
  };

  const handleOpenModal2 = (index: number) => {
    setEditModal2(index);
  };

  const handleCloseModal2 = useCallback(() => {
    setEditModal2(null);
  }, []);

  const token = localStorage.getItem("token");

  //To add role
  const handleRoles = (event: SelectChangeEvent<typeof roles>) => {
    const selectedRoles = event.target.value as string[];

    setRoles(selectedRoles);
  };
  //To delete role.
  const handleDeleteRole = (role: string) => {
    const updatedRoles = roles.filter((r) => r !== role);
    setRoles(updatedRoles);
  };

  //To Edit Role.
  const handlePersonRoles = (e: SelectChangeEvent<string>) => {
    const { value } = e.target;
    if (!personData.roles.includes(value)) {
      setPersonData((prevPersonData) => ({
        ...prevPersonData,
        roles: [...prevPersonData.roles, value],
      }));
    }
  };

  //To delete Edit role.
  const handlePersonDeleteRole = (role: string) => {
    setPersonData((prevPersonData) => ({
      ...prevPersonData,
      roles: prevPersonData.roles.filter((r) => r !== role),
    }));
  };

  //To handle Edit State.
  const handlePersonChange = (e: any) => {
    let name, value;
    name = e.target.name;
    value = e.target.value;
    const regex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
    const hasSpecialChar = regex.test(value);

    setPersonData({ ...personData, [name]: value });
    setIsSpecialCharError2(hasSpecialChar);
  };

  //To handle Add State.
  const handleChange = (event: any, index: number) => {
    event.preventDefault();
    let name, value;
    name = event.target.name;
    value = event.target.value;
    const regex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
    const hasSpecialChar = regex.test(value);
    const nameRegex = /^[a-zA-Z' ]*$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex =
      /^(?!\s)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+,\-.;:'"<>/?])(?=.*\d)[^\s]{8,}$/;

    const specialCharacter = /^(?=.*[!@#$%^&*()_+,\-.;:'"<>/?])/;
    const oneUpperCase = /^(?=.*[A-Z])/;
    const oneLowerCase = /^(?=.*[a-z])/;
    const oneNumber = /^(?=.*\d)/;
    const noSpaces = /^[^\s]+$/;

    if (name === "password") {
      setIsValidPassword({
        specialCharacter: specialCharacter.test(value),
        oneUpperCase: oneUpperCase.test(value),
        oneLowerCase: oneLowerCase.test(value),
        oneNumber: oneNumber.test(value),
        spacesError: !noSpaces.test(value),
        minCharacter: value.length < 8,
      });
    }

    if (name === "first_name" || "last_name") {
      setIsSpecialCharError(false);
      const isNameValid = !nameRegex.test(value);
      setNameError((prevNameError) => {
        const updatedNameError = [...prevNameError];
        updatedNameError[index] = isNameValid;
        return updatedNameError;
      });
    }
    // setIsSpecialCharError(hasSpecialChar);
    setAddEmployee({ ...addEmployee, [name]: value });
    if (name === "email") {
      setIsSpecialCharError(false);
      const isEmailValid = !emailRegex.test(value);
      setNameError((prevNameError) => {
        const updatedNameError = [...prevNameError];
        updatedNameError[index] = isEmailValid;
        return updatedNameError;
      });
    }

    setErrorMessage("");
  };

  const validatePassword = (value: any) => {
    const isValid: any = {
      specialCharacter: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value),
      oneUpperCase: /[A-Z]/.test(value),
      oneLowerCase: /[a-z]/.test(value),
      oneNumber: /\d/.test(value),
      spacesError: /^[^\s]+$/.test(value),
      minCharacter: value.length >= 8,
    };

    setIsValidPassword(isValid);

    const firstError = Object.keys(isValid).find((key) => !isValid[key]);
    if (firstError) {
      switch (firstError) {
        case "specialCharacter":
          setErrorMessage(
            "Password must contain at least one special character."
          );
          setIsS(true);
          break;
        case "oneUpperCase":
          setErrorMessage(
            "Password must contain at least one uppercase letter."
          );
          setIsS(true);

          break;
        case "oneLowerCase":
          setErrorMessage(
            "Password must contain at least one lowercase letter."
          );
          setIsS(true);

          break;
        case "oneNumber":
          setErrorMessage("Password must contain at least one number.");
          setIsS(true);

          break;
        case "minCharacter":
          setErrorMessage("Password should be at least 8 characters long.");
          setIsS(true);

          break;
        case "spacesError":
          setErrorMessage("Password should not contain any spaces.");
          setIsS(true);

          break;
        default:
          setErrorMessage("");
      }
    } else {
      setErrorMessage("");
    }
  };

  //To Edit Employee Details API Call.
  const handleSave = async (
    event: React.MouseEvent<HTMLElement> | React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();

    const {
      employee_code,
      first_name,
      last_name,
      gender,
      roles,
      designation,
      email,
      password,
    } = personData;

    const yodaPlusEmailPattern = /^[a-zA-Z0-9._%+-]+@yodaplus\.com$/;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validEmail = emailPattern.test(email);

    var data = {
      employee_code: employee_code,
      first_name: first_name,
      last_name: last_name,
      gender: gender === "Other" ? otherGender : gender,
      roles: personData.roles.map((data) => {
        return {
          role: data,
        };
      }),
      designation: designation,
      date_of_birth: dateOfBirth
        ? format(dateOfBirth.toDate(), "yyyy-MM-dd")
        : "",
      date_of_joining: dateOfJoining
        ? format(dateOfJoining.toDate(), "yyyy-MM-dd")
        : "",
    };

    //for editing a particular employee
    try {
      const response = dispatch2(patchData(`${updateEmployee}${email}`, data))
        .then((response) => {
          handleShowToast("Successfully Updated Profile Info", "success", true);
          dispatch(postDataSuccess(null));

          setCount(count + 1);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }

    setAddEmployee(initialStateEmployee);
    setRoles([]);
    setOpen(false);
  };

  //adding a new  employee
  const handleSubmit = async (event: any) => {
    event.preventDefault();

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const {
      employee_code,
      first_name,
      last_name,
      gender,
      designation,
      email,
      password,
    } = addEmployee;

    const validEmail = emailPattern.test(email);

    validatePassword(password);

    if (errorMessage !== "" || isS === true) {
      return;
    }

    const passwordRegex =
      /^(?!\s)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+,\-.;:'"<>/?])(?=.*\d).{8,}$/;

    var data = {
      employee_code: employee_code,
      first_name: first_name,
      last_name: last_name,
      gender: gender === "Other" ? otherGender : gender,
      roles: roles.map((data) => {
        return {
          role: data,
        };
      }),
      designation: designation,
      date_of_birth: dateOfBirth
        ? format(dateOfBirth.toDate(), "yyyy-MM-dd")
        : "",
      date_of_joining: dateOfJoining
        ? format(dateOfJoining.toDate(), "yyyy-MM-dd")
        : "",
      email: email,
      password: password,
    };
    try {
      const response = dispatch2(postData(`${registerUser}`, data)).then(
        (response) => {
          setCount(count + 1);
          handleShowToast("Employee Added Successfully", "success", true);
          setCount(count + 1);
          setAddEmployee(initialStateEmployee);
          setRoles([]);
          setNameError([]);
          setOpen(false);
          setErrorMessage("");
          dispatch(postDataSuccess(null));

          setIsValidPassword({
            spacesError: false,
            specialCharacter: false,
            minCharacter: false,
            oneLowerCase: false,
            oneNumber: false,
            oneUpperCase: false,
          });
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  //deleting employee
  const handleDelete = useCallback(async (email: string) => {
    try {
      const response = await dispatch2(deleteData(`${DeleteEmp}${email}`))
        .then((response) => {
          handleShowToast("Employee deleted", "success", true);
          
          // Update local state instead of refetching
          setGetEmployee((prevEmployees) =>
            prevEmployees.filter((emp) => emp.email !== email)
          );
          
          handleCloseModal2();
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }, [dispatch2, handleShowToast, handleCloseModal2]);
// Export Functionality
  const handleExport = () => {
    const exportData = filteredData.map((emp) => ({
      "Employee Code": emp.employee_code,
      "Employee Name": `${emp.first_name} ${emp.last_name}`,
      "Designation": emp.designation || "",
      "Reporting Manager 1": m1Managers[emp.id] || "Unassigned",
      "Reporting Manager 2": m2Managers[emp.id] || "Unassigned",
      "Status": emp.is_active ? "Active" : "Inactive",
    }));
    
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");
    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "employee-details.xlsx");
  };

  //for showing all the employeess
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        dispatch(setIsLoading(true));
        const response: DataPayload = await dispatch2(
          fetchData(`${viewUsers}`)
        );
        dispatch(setIsLoading(false));
        setGetEmployee(response as (typeof initialStateEmployee)[]);
      } catch (error) {
        console.log(error);
        dispatch(setIsLoading(false));
        setRoles([]);
        setAddEmployee(initialStateEmployee);
        setDateOfBirth(dayjs(date));
        setDateOfJoining(dayjs(date));
        setNameError([]);
      }
    };

    fetchUserDetails();
  }, [count, counts]);

  useEffect(() => {
    const fetchReportingManagers = async () => {
      const m1Map: Record<string, string> = {};
      const m2Map: Record<string, string> = {};

      try {
        // Fetch all active manager assignments in one call, in parallel with employee list fetch
        const assignments: any[] = (await dispatch2(
          fetchData(`${managerAssignmentsUrl}`)
        )) as any[];

        if (Array.isArray(assignments)) {
          for (const a of assignments) {
            if (!a.is_active || !a.manager_name) continue;
            const eid = typeof a.employee === "string" ? a.employee : String(a.employee);
            if (a.manager_level === "M1") m1Map[eid] = a.manager_name;
            if (a.manager_level === "M2") m2Map[eid] = a.manager_name;
          }
        }
      } catch (error) {
        console.log("Error fetching manager assignments:", error);
      }

      setM1Managers(m1Map);
      setM2Managers(m2Map);
    };

    fetchReportingManagers();
  }, [count, counts]);
  useEffect(() => {
    handleClose();
    dispatch(setisOpen(false));
    setCount(count + 1);
  }, [isOpen]);

  if (isloading) {
    return (
      <>
        <Loading isLoading={isloading as boolean} />
      </>
    );
  }

  return (
    <>

      {/* EMPLOYEE DETAILS */}

      <Box sx={{ mt: 12, mb: 10, display: "flex", justifyContent: "center", px: 2 }}>
        <Box
          sx={{
            width: "100%",
            maxWidth: "1400px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ mb: 3 }}>
            <PageTitle>Employee Details</PageTitle>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, gap: 2 }}>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", flex: 1 }}>
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={statusFilter}
                  label="Status"
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
              <Autocomplete
                multiple
                size="small"
                options={Array.from(
                  new Set([
                    ...Object.values(m1Managers),
                    ...Object.values(m2Managers),
                  ].filter(Boolean))
                ).sort((a, b) => a.localeCompare(b))}
                value={reportingManagerFilter}
                onChange={(event, newValue) => {
                  setReportingManagerFilter(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Reporting Manager" placeholder="Select managers" />
                )}
                sx={{ minWidth: 250 }}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="contained"
                size="small"
                onClick={() => Navigate("/assign-manager/form")}
              >
                Assign Manager
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={handleExport}
              >
                Export
              </Button>
              <Button
                id="addEmployeeButton"
                variant="contained"
                size="small"
                onClick={() => Navigate("/addEmployee")}
              >
                Add Employee
              </Button>
            </Box>
          </Box>
          <Box sx={{ width: "100%" }}>
            {rows.length === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  p: 2,
                }}
              >
                <NothingToDisplayComponent />
              </Box>
            ) : (
              <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <DataGrid
                  autoHeight
                  getRowId={(row) => row.id}
                  getRowHeight={() => "auto"}
                  disableColumnMenu
                  sx={{
                    width: "100%",
                    "--DataGrid-overlayHeight": "50vh",
                    "& .MuiDataGrid-main": {
                      overflow: "auto",
                    },
                  }}
                  {...getDataGridPaginationProps()}
                  pagination
                  rows={rows}
                  columns={columns}
                  disableColumnFilter
                  disableColumnSelector
                  disableDensitySelector
                  slots={{
                    toolbar: GridToolbar,
                    noResultsOverlay: CustomNoRowsOverlay,
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  slotProps={{
                    toolbar: {
                      csvOptions: { disableToolbarButton: true },
                      showQuickFilter: true,
                      printOptions: { disableToolbarButton: true },
                      style: { margin: "0.5rem" },
                      quickFilterProps: {
                        size: "medium",
                        sx: {
                          "& .MuiInputBase-input::placeholder": {
                            color: "#3c3c3c",
                            opacity: 1,
                          },
                        },
                      },
                    },
                  }}
                />
              </Paper>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AddEmployee;
